import React from "react";
import { DatePicker } from "../DatePicker";
import { DateProps } from "../types";
import useMediaQuery from "@/hooks/useMediaQuery";
import { FieldValues } from "react-hook-form";
import useDefaultValueAs from "@/hooks/useDefaultValueAs";

const Date = (props: DateProps<FieldValues>) => {
  const isTablet = useMediaQuery("tablet");

  useDefaultValueAs({ field: props.field, setValue: props.setValue, values: props.values });

  return (
    <DatePicker
      {...props}
      isTablet={isTablet}
    />
  );
};

export default Date;
